var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shehuigongnengkaifake"},[_c('PublicCert',{attrs:{"logo":_vm.Logo11,"type":'jy-sf',"color":'#294db0'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }